import storejs from 'store'

const NotificationInstance = Notification || window.Notification
// console.log('NotificationInstance ----', NotificationInstance)

function initNotification() {
  if (!!NotificationInstance) {
    const permissionNow = NotificationInstance.permission
    // console.log('permissionNow ----', permissionNow)
    if (permissionNow === 'granted') {
      // createNotification()
    } else if (permissionNow === 'default') {
      reqPermisson()
    }
  }
}

function reqPermisson() {
  NotificationInstance.requestPermission(function (PERMISSION) {
    if (PERMISSION === 'granted') {
      // createNotification()
    }
  })
}

function createNotification(body, url) {
  // console.log('createNotification')
  const app = storejs.get('app')
  const notice = new NotificationInstance(`${app.title}后台消息通知`, {
    body,
    // tag: '2',
    renotify: false,
    data: {
      url
    }
  })
  notice.onshow = function () {
    console.log('通知显示了')
  }
  notice.onclick = function (event) {
    event.preventDefault();
    // console.log('in click')
    window.open(notice.data.url, '_blank')
    notice.close()
  }
  notice.onclose = function () {
    console.log('关闭了')
  }
  notice.onerror = function (err) {
    console.log('出错了')
  }
  const timeout = setTimeout(() => {
    notice.close()
    clearTimeout(timeout)
  }, 5000)
}

export {
  initNotification,
  createNotification
}